import {createSlice} from '@reduxjs/toolkit';
import {Storage} from '../utils/storage';
import {BoardSettings, FeatureFlag, ResponseSpeed} from '../types';
import {Theme} from 'ghostban';

const globalBoardSettingsInitialState: BoardSettings = {
    theme: Theme.Flat,
    moveSound: true,
    moveSoundVolume: 0.5,
    boardSize: undefined,
    variationsIndicator: false,
    responseSpeed: ResponseSpeed.FAST,
    coordinate: true,
    number: false,
};

export const globalBoardSettingsSlice = createSlice({
    name: 'globalBoardSettings',
    initialState: globalBoardSettingsInitialState,
    reducers: {
        setGlobalBoardSettings: (state, action) => {
            const newState = {
                ...state,
                ...action.payload,
            };
            Storage.storeObjData('globalBoardSettings', newState);
            return (state = newState);
        },
    },
});

const aiSettingsInitialState = {
    backend: 'auto',
    model: 'kata1-b10c128-s1141046784-d204142634',
    network: 'b10',
    debug: false,
    maxVisits: 500,
};

export const aiSettingsSlice = createSlice({
    name: 'aiSettings',
    initialState: aiSettingsInitialState,
    reducers: {
        setAiSettings: (state, action) => {
            const newState = {
                ...state,
                ...action.payload,
            };
            Storage.storeObjData('aiSettings', newState);
            return (state = newState);
        },
    },
});

const featureFlags: FeatureFlag[] = [];
export const featureFlagsSlice = createSlice({
    name: 'featureFlags',
    initialState: featureFlags,
    reducers: {
        setFeatureFlags: (state, action) => {
            const newState = action.payload;
            Storage.storeObjData('featureFlags', newState);
            return (state = newState);
        },
    },
});
